import { Sparkles } from "lucide-react";
import { Badge } from "@/shared/ui/Badge";

type Props = {
  discountPercent: number
  title?: string
};

export const PackPromotionBadge = ({ discountPercent, title }: Props) => (
  <Badge
    variant="default"
    className="gap-1 bg-emerald-500 text-white"
    title={title}
  >
    <Sparkles size={12} aria-hidden="true" />
    {`-${discountPercent}%`}
  </Badge>
);
